export default { MODULE_NAME: 'passwordReset' };
